// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"489":"component---src-templates-landing-page-template-index-tsx","532":"styles","774":"framework","856":"42d084c6"}[chunkId] || chunkId) + "-" + {"489":"c9c2bad77e07ffc59051","532":"da43094a3b866891d451","589":"faf503b060eaf38cf630","774":"8c0b500f3d07a0990811","856":"d56713d3b5f1f41bdc65"}[chunkId] + ".js";
};